import Header from "../header";
import Footer from "../footer";
import { useNavigate,useLocation} from "react-router-dom";
import { useState, useEffect } from "react";
import { submitClaim } from "apiCalls/applyClaimService";
import { useLanguage } from "context/LanguageContext";

function maskAadhaar(val) {
    if (!val || val === "-") return "-";
    const digits = String(val).replace(/\D/g, "");
    if (digits.length === 12) return `XXXX XXXX ${digits.slice(8)}`;
    return "XXXX XXXX XXXX";
}

function formatDate(iso) {
    if (!iso) return "-";
    const d = new Date(iso);
    if (isNaN(d)) return iso;
    return `${String(d.getDate()).padStart(2,"0")}/${String(d.getMonth()+1).padStart(2,"0")}/${d.getFullYear()}`;
}

function PreviewDiseaseClaim(){
    const navigate = useNavigate();
    const { state } = useLocation();
    const { t } = useLanguage();
    const loan = state?.loan || {};
    const claim = state?.claim || {};
    const files = state?.files || {};
    const draftId = state?.draftId || sessionStorage.getItem("previewDraftId") || null;

    useEffect(() => {
        if (!state?.loan) navigate("/userDashboard", { replace: true });
    }, []);
    const [showSuccess, setShowSuccess] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [applicationNumber, setApplicationNumber] = useState("");
    const [medCertUrl, setMedCertUrl] = useState(null);
    const [dobProofUrl, setDobProofUrl] = useState(null);
    const [dobProofDocFileUrl, setDobProofDocFileUrl] = useState(null);
    const [anotherDocFileUrl, setAnotherDocFileUrl] = useState(null);

    useEffect(() => {
        const url1 = files.medicalCertificateFile ? URL.createObjectURL(files.medicalCertificateFile) : null;
        const url2 = files.dobProofFile ? URL.createObjectURL(files.dobProofFile) : null;
        const url3 = files.dobProofDocFile ? URL.createObjectURL(files.dobProofDocFile) : null;
        const url4 = files.anotherDocFile ? URL.createObjectURL(files.anotherDocFile) : null;
        if (url1) setMedCertUrl(url1);
        if (url2) setDobProofUrl(url2);
        if (url3) setDobProofDocFileUrl(url3);
        if (url4) setAnotherDocFileUrl(url4);
        return () => {
            if (url1) URL.revokeObjectURL(url1);
            if (url2) URL.revokeObjectURL(url2);
            if (url3) URL.revokeObjectURL(url3);
            if (url4) URL.revokeObjectURL(url4);
        };
    }, []);

    const handleSubmit = async () => {
        setSubmitting(true);
        setErrorMsg("");
        const fd = new FormData();
        if (draftId) fd.append("risk_fund_claim_id", draftId);
        fd.append("risk_fund_claim_type_id", btoa("1"));
        fd.append("loan_number", loan.loanNo);
        fd.append("disease_id", claim.diseaseCategory);
        if (claim.hospitalCategory) fd.append("hospital_category_id", btoa(String(claim.hospitalCategory)));
        fd.append("hospital_id", btoa(String(claim.hospitalId)));
        fd.append("illness_start_date", claim.dateOfIllness);
        fd.append("medical_certificate_date", claim.dateOfMedicalCertificate);
        fd.append("medical_certificate_file", files.medicalCertificateFile);
        fd.append("dob_proof_file", files.dobProofFile);
        if (claim.dobProofDocTypeName) fd.append("id_proof_name", claim.dobProofDocTypeName);
        if (files.dobProofDocFile) fd.append("id_proof_file", files.dobProofDocFile);
        if (claim.anotherDocName) fd.append("other_document_name", claim.anotherDocName);
        if (files.anotherDocFile) fd.append("other_document_file", files.anotherDocFile);
        try {
            const res = await submitClaim(fd);
            setApplicationNumber(res.data?.application?.application_number || "");
            sessionStorage.removeItem("previewDraftId");
            setShowSuccess(true);
        } catch (err) {
            setErrorMsg(err.message || t.somethingWentWrong);
        } finally {
            setSubmitting(false);
        }
    };

    return(
        <>
            <Header/>
            {/*-- ==== Scroll up and prograss start ==== */}
            <div id="scrollUp">
                <svg className="arrowup" viewBox="0 0 24 24" width="18" height="18">
                    <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z" fill="#fff"></path>
                </svg>
                <svg className="scrollprogress" width="40" height="40">
                    <circle className="progress-circle" cx="20" cy="20" r="18" strokeWidth="2" fill="none" stroke="#fff" strokeDasharray="113.1" strokeDashoffset="113.1"></circle>
                </svg>
            </div>
            {/*-- ==== Scroll up and prograss Ends ==== */}
            {/* ==== Account Creation Page Banner Section Start ==== */}
            <section className="rs-page-banner rs-faq-page-banner pt-30 pb-30 mt-140">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7">
                            <div className="rs-page-banner__content">
                                <h1 className="title">{t.previewDiseaseClaimTitle}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/*- ==== Account Creation Page Banner Section Ends ==== */}
            {/*-- ====Page Section Start ==== */}
    <section className="rs-faq-page pt-50 pb-120">
        <div className="container">

            <div className="row justify-content-center">
                <div className="col-lg-12">

                    {/*--loan details--*/}
                    <h5 className="mb-2">{t.loanDetails}</h5>
                    <div className="list-type mb-5">
                        <div className="row">
                            <div className="col-md-3 mb-2">
                                <p>{t.loaneeFullName}</p>
                                <h4>{loan.name}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p>{t.aadhaarNumber}</p>
                                <h4>{maskAadhaar(loan.aadhaar)}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p>{t.mobileNumber}</p>
                                <h4>{loan.mobile}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p>{t.loanNumber}</p>
                                <h4>{loan.loanNo}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p>{t.loanAmount}</p>
                                <h4>{loan.amount}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p>{t.societyMembership}</p>
                                <h4>{loan.membership}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p>{t.societyName}</p>
                                <h4>{loan.society}</h4>
                            </div>
                             <div className="col-md-3 mb-2">
                                <p>{t.societyAddress}</p>
                                <h4>{loan.societyAddress}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p>{t.dateOfBirth}</p>
                                <h4>{loan.dob}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p>{t.birthCertificate}</p>
                                <h4>{loan.birthCertificateNumber}</h4>
                            </div>
                        </div>
                    </div>
                    {/*--loan details--*/}
                    {/*-- Diseas Claim Details */}
                     <h5 className="mb-2">{t.diseaseClaimDetails}</h5>
                     <div className="list-type mb-5">
                        <div className="row">
                            <div className="col-md-3 mb-2">
                                <p>{t.diseaseCategory}</p>
                                <h4>{claim.diseaseCategoryName || claim.diseaseCategory}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p>{t.dateOfIllness}</p>
                                <h4>{formatDate(claim.dateOfIllness)}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p>{t.hospitalCategory}</p>
                                <h4>{claim.hospitalCategoryName}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p>{t.medicalCertIssuedBy}</p>
                                <h4>{claim.medicalCertificateIssuedBy}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p>{t.medicalCertDate}</p>
                                <h4>{formatDate(claim.dateOfMedicalCertificate)}</h4>
                            </div>
                        </div>
                    </div>
                    {/*-- Diseas Claim Details */}

                    {/* Uploaded Documents */}
                    <h5 className="mb-2">{t.uploadedDocuments}</h5>
                    <div className="list-type mb-5">
                        <div className="row">
                            {medCertUrl && (
                                <div className="col-md-4 mb-2">
                                    <p>{t.medicalCertificate}</p>
                                    <a href={medCertUrl} target="_blank" rel="noopener noreferrer" style={{ color: "#1a5c4a", fontSize: "0.9rem" }}>
                                        <i className="fa fa-file me-1"></i> {t.viewDoc}
                                    </a>
                                </div>
                            )}
                            {dobProofUrl && (
                                <div className="col-md-4 mb-2">
                                    <p>{t.dobProof}</p>
                                    <a href={dobProofUrl} target="_blank" rel="noopener noreferrer" style={{ color: "#1a5c4a", fontSize: "0.9rem" }}>
                                        <i className="fa fa-file me-1"></i> {t.viewDoc}
                                    </a>
                                </div>
                            )}
                            {dobProofDocFileUrl && (
                                <div className="col-md-4 mb-2">
                                    <p>{claim.dobProofDocTypeName || t.uploadIdProofDoc}</p>
                                    <a href={dobProofDocFileUrl} target="_blank" rel="noopener noreferrer" style={{ color: "#1a5c4a", fontSize: "0.9rem" }}>
                                        <i className="fa fa-file me-1"></i> {t.viewDoc}
                                    </a>
                                </div>
                            )}
                            {anotherDocFileUrl && (
                                <div className="col-md-4 mb-2">
                                    <p>{claim.anotherDocName || t.anotherDocument}</p>
                                    <a href={anotherDocFileUrl} target="_blank" rel="noopener noreferrer" style={{ color: "#1a5c4a", fontSize: "0.9rem" }}>
                                        <i className="fa fa-file me-1"></i> {t.viewDoc}
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>

                     {errorMsg && (
                        <div className="alert alert-danger mt-3">{errorMsg}</div>
                    )}
                     <div className="row mt-4">
                        <div className="col-md-12 text-end">
                            <button className="btn btn-secondary me-3" onClick={()=>navigate("/diseaseClaim", { state: { loan, claim, draftId, files } })}><i className="fa fa-angle-left me-2"></i>{t.back}</button>
                            <button type="button" className="btn btn-primary me-3" disabled={submitting} onClick={handleSubmit}>
                                {submitting
                                    ? <><span className="spinner-border spinner-border-sm me-2"></span>{t.submitting}</>
                                    : <><i className="fa fa-check-circle me-2"></i>{t.submit}</>
                                }
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </section>

            <Footer/>

            {showSuccess && (
                <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <div className="card text-center p-5" style={{ maxWidth: "420px", width: "90%" }}>
                        <div className="mb-3">
                            <i className="fa fa-check-circle" style={{ fontSize: "3.5rem", color: "#25826a" }}></i>
                        </div>
                        <h4 className="mb-2">{t.claimSubmittedSuccess}</h4>
                        {applicationNumber && (
                            <div className="mb-2 px-3 py-2 rounded" style={{ backgroundColor: "#eaf4f0", border: "1px solid #c2ddd5" }}>
                                <span className="text-muted small">{t.applicationNo}</span>
                                <div className="fw-bold" style={{ color: "#1a5c4a", fontSize: "1.1rem", letterSpacing: "0.5px" }}>{applicationNumber}</div>
                            </div>
                        )}
                        <p className="text-muted mb-4">{t.diseaseClaimSubmittedDesc}</p>
                        <button className="btn btn-primary" onClick={() => navigate("/userDashboard")}>{t.goHome}</button>
                    </div>
                </div>
            )}
        </>
    )
}

export default PreviewDiseaseClaim